import styled, {css, DefaultTheme} from 'styled-components'
import * as RTooltip from '@radix-ui/react-tooltip'
import {CSSProperties} from 'react'

type StyledTooltipProps = {
    $variant: 'light' | 'dark'
    $maxWidth?: CSSProperties['maxWidth']
}

export const StyledTooltipContent = styled(RTooltip.Content)<StyledTooltipProps>`
    ${({theme: {spacing, typography, shadows, zIndex}, $maxWidth}) => css`
        padding: ${spacing * 2}px ${spacing * 3}px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        box-shadow: ${shadows.lg};
        ${typography.textXs};
        font-weight: 500;
        z-index: ${zIndex.tooltip};
        max-width: ${$maxWidth ?? '90vw'};
        word-break: break-word;
    `}
    ${({$variant, theme}) => ColorStyles(theme)[$variant]};
`

/**
 * Styled directly on RTooltip.Arrow instead of via a `svg` selector on StyledTooltipContent:
 * Radix wraps the arrow's <svg> in its own positioning <span>, so it's a grandchild (not a
 * direct child) of the content box and a `& > svg` selector never reaches it.
 */
export const StyledTooltipArrow = styled(RTooltip.Arrow)<{$variant: 'light' | 'dark'}>`
    ${({$variant, theme: {palette}}) => css`
        fill: ${$variant === 'light' ? palette.neutral.white : palette.neutral['950']};
    `}
`

const ColorStyles = ({palette}: DefaultTheme) => ({
    light: css`
        background: ${palette.neutral['25']};
        color: ${palette.neutral['700']};
    `,
    dark: css`
        background: ${palette.neutral['950']};
        color: ${palette.neutral.white};
    `
})
